import FloatingWarning from "./FloatingWarningV2";
import { isMobile } from "react-device-detect";

type Props = {
    isLandscapeMode: boolean
}

export default function LandscapeModeWarning({ isLandscapeMode }: Props) {

    return <FloatingWarning
        getMessage={() => {
            return <div>Para uma melhor experiência, utilize a aplicação no modo retrato.</div>;
        }} visible={isMobile && isLandscapeMode} getExtendedMessage={undefined} customPosition={20} />
}